module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEFSURBVHgBtZUNEYMwDIV7U4AEJEzCpmSVgANwAA4mAQlIQEIkIOEtHemNlf7C9t3l6LW9R5o0qVIBAFRsDdvIRvhgxhObZqtVLiLYsi1IY37S5ojWbDPKoaD3Iko4DnnFcU7UMruiLX5HdzYEA9Zb42KSXhlhjXJo45SP5sLrD1XOXb6hq3Y7krRBvNXRE0UWfQVCWAsomZeQ8CJe3Zx5LfM9EsRCcRURm/lnImFb3qEYQ4uQSsJ6teqCQpq2Hvn4qiTkF5K23SzWyfqCEBgItmfwoEtsnpDXRg2dco55pF260K5U8K+2eVJ8Rs4zhTXmlCG4yN5K5SLem34wYf+YmrvfxARfY9avfLsEUMMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gou.png
// module id = +zt/
// module chunks = 1